<template>
  <div>
    <b-notification
        v-model="isError"
        type="is-danger"
        aria-close-label="Close notification"
        :closable="false">
        <b>Error fetching ingredient aisle!</b><br />Try refreshing the page. If the error persists check your network connection or let BM know.
    </b-notification>
    <b-loading :is-full-page="true" v-model="isLoading"></b-loading>

    <!-- Sticky Top Bar with Breadcrumb -->
    <TopBar
      v-if="!isLoading && !isError"
      parentTitle="Aisles"
      :currentTitle="aisle.name || 'New Aisle'"
      :backRoute="{ name: 'IngredientAisleListView' }"
    >
      <b-button outlined type="is-primary" size="is-small" icon-left="check" @click="saveAndClose">Save & Close</b-button>
      <b-button type="is-primary" size="is-small" icon-left="content-save" @click="save">Save</b-button>
    </TopBar>

    <div v-if="!isLoading && !isError" class="page-content">
      <!-- Page Header -->
      <div class="page-header">
        <div class="page-title-group">
          <h1 class="page-title">{{ aisle.name || 'New Aisle' }}</h1>
          <p class="page-subtitle">Ingredient Aisle Editor</p>
        </div>
      </div>

      <!-- Form Card -->
      <FeedsCard title="Aisle Details">
        <div class="form-group">
          <label class="form-label">Aisle Name</label>
          <b-input
            v-model="aisle.name"
            placeholder="e.g. eggs, dairy & bread"
            @input="saveDebounced" />
          <p class="form-hint">This will be seen by the end user in the shopping list</p>
        </div>
        <div class="form-group">
          <label class="form-label">Position</label>
          <b-numberinput
            v-model="aisle.position"
            placeholder="e.g. 1"
            type="is-light"
            controls-position="compact"
            :min="1"
            @input="saveDebounced">
          </b-numberinput>
          <p class="form-hint">This is the aisle's position in the shopping list</p>
        </div>
      </FeedsCard>
    </div>
  </div>
</template>

<script>
import debounce from 'lodash/debounce'
import db from "@/firebase/db"
import FeedsCard from "@/components/common/FeedsCard"
import TopBar from "@/components/layout/TopBar"

export default {
  name: 'IngredientAisleView',
  components: {
    FeedsCard,
    TopBar
  },
  props: [
    'id'
  ],
  data() {
    return {
      isLoading: true,
      isError: false,
      aisle: {},
    };
  },
  created: function () {
    db.collection('ingredient_aisles')
      .doc(this.id)
      .get()
      .then(snapshot => {
        if (snapshot.exists) {
          this.aisle = snapshot.data();
          this.aisle.id = this.id;
        }else {
          this.isError = true;
        }
        this.isLoading = false;
      })
      .catch((error) => {
        this.isError = true;
        this.$buefy.notification.open({type: 'is-danger', message: `Error fetching ingredient aisle: ${error}`})
      });
  },
  methods: {
    saveDebounced: debounce(function () {
      this.save()
    }, 1000),
    async saveAndClose(){
      this.save()
        .then(() => {
          this.$router.go(-1)
        })
    },
    async save(){
      db.collection('ingredient_aisles')
        .doc(this.id)
        .set(this.aisle)
        .then(() => {
          this.$buefy.toast.open({type: 'is-success', message: `Ingredient aisle successfully updated!`})
        })
        .catch((error) => {
          this.$buefy.toast.open({type: 'is-danger', message: `Error saving ingredient aisle: ${error}`})
        });
    },
  }
}
</script>
